import { Link } from 'react-router';

import { useSoftwareEscrow } from 'src/context/software-escrow';
import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { DepositorReadOnlyCard, EscrowDepositorCore } from 'src/containers/Escrow/Depositor';

type IDepositorContentApp = {
  name?: string | null;
  owned: boolean;
  ownerName: string;
};

// The app's owner is the depositor and manages its details; anyone else sees the vendor's app read-only
const getDepositorContent = ({ name, owned, ownerName }: IDepositorContentApp) => {
  if (owned)
    return {
      title: 'Depositor information and signatories',
      description:
        'Check your organization details and add the key points of contact and authorized signatories for this escrow.',
      noteText:
        "Note: Once all parties approve the escrow, we'll send e-signature requests via Dropbox Sign to the designated signatories to make the agreement legally binding.",
      hintText: (
        <>
          Need a different signing method or a hardcopy agreement?{' '}
          <Link to="/help-resources/contact-us" className="text-accent-software-escrow underline!">
            Contact us
          </Link>
          .
        </>
      ),
    };

  const appName = name ?? 'this application';

  return {
    title: 'Depositor information',
    description: `${ownerName} owns ${appName} and is the depositor on this agreement. You can't edit these details — ${ownerName} confirms them when reviewing the agreement.`,
    noteText: undefined,
    hintText: undefined,
  };
};

const DepositorContent = () => {
  const {
    softwareEscrow: { id: escrowId, depositor, agreement, app },
  } = useSoftwareEscrow();

  if (!app.owned) return <DepositorReadOnlyCard app={app} />;

  return (
    <EscrowDepositorCore depositorId={depositor!.id} escrowId={escrowId} agreementType={agreement.agreementForm!} />
  );
};

const SoftwareEscrowOnboardingDepositor = () => {
  const {
    softwareEscrow: { app },
  } = useSoftwareEscrow();

  const { title, description, noteText, hintText } = getDepositorContent(app);

  return (
    <SoftwareOnboardingMain
      subtitle="Depositor"
      title={title}
      description={description}
      noteText={noteText}
      hintText={hintText}
    >
      <div className="max-w-260 w-full mx-auto space-y-4">
        <DepositorContent />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default SoftwareEscrowOnboardingDepositor;
